import React, { ReactElement } from 'react';
import {
  MenuItem,
  TextField,
  StandardTextFieldProps,
  InputAdornment,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import Select from 'react-select';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import CancelIcon from '@material-ui/icons/Cancel';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { Control, Controller } from 'react-hook-form';
import { makeStyles, useTheme } from '@material-ui/core/styles';

interface Iprops extends StandardTextFieldProps {
  options: Array<any>;
  control: Control<any>;
  rules: any;
  selectedKey: string;
  name: string;
  handleChange?: (data: string) => void;
  controllerExtras?: any;
  style?: React.CSSProperties;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
    margin: '1rem',
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light'
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
}));

function NoOptionsMessage(props: any) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }: any) {
  return <div ref={inputRef} {...props} />;
}

function Control1(props: any) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props: any) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props: any) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props: any) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props: any) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}

function MultiValue(props: any) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props: any) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Control: Control1,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

// function IntegrationReactSelect() {
//   const classes = useStyles();
//   const theme = useTheme();
//   const [single, setSingle] = React.useState(null);
//   const [multi, setMulti] = React.useState(null);

//   function handleChangeSingle(value) {
//     setSingle(value);
//   }

//   function handleChangeMulti(value) {
//     setMulti(value);
//   }

//   const selectStyles = {
//     input: base => ({
//       ...base,
//       color: theme.palette.text.primary,
//       '& input': {
//         font: 'inherit',
//       },
//     }),
//   };

export default function AutoCompleteSelect(props: Iprops) {
  const {
    control,
    rules,
    options,
    handleChange,
    selectedKey,
    style,
    id,
    controllerExtras = {},
    ...other
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  // const [single, setSingle] = React.useState(null);
  // const [multi, setMulti] = React.useState(null);

  // function handleChangeSingle(value: any) {
  //   setSingle(value);
  // }

  // function handleChangeMulti(value: any) {
  //   setMulti(value);
  // }

  const selectStyles = {
    input: (base: any) => ({
      ...base,
      color: (theme as any).palette.text.primary,
      '& input': {
        font: 'inherit',
      },
    }),
  };

  return (
    <Controller
      render={(props) => (
        // <Select
        //   {...props}
        //   classes={classes}
        //   styles={selectStyles}
        //   options={suggestions}
        //   components={components}
        //   // value={single}
        //   // onChange={handleChangeSingle}
        //   onChange={props.onChange}

        //   // placeholder="Search a country (start with a)"
        // />
        <span>Deprecated</span>
        // <Select
        //   {...props}
        //   classes={classes}
        //   styles={selectStyles}
        //   options={options}
        //   components={components}
        //   // value={this.state.single}
        //   // onChange={this.handleChange('single')}
        //   isClearable
        // />

        // <Autocomplete
        //   {...props}
        //   options={options}
        //   getOptionLabel={(option) => `${option[selectedKey]}`}
        //   renderInput={(params) => (
        //     <TextField
        //       variant="outlined"
        //       {...params}
        //       {...other}
        //       value={'other.value'}
        //     />
        //   )}
        //   onChange={(__, data) => {
        //     // const result = _.get(data, selectedKey);
        //     handleChange && handleChange(data || '');
        //     props.onChange(data);
        //   }}
        // />

        // <Autocomplete
        //   {...props}
        //   options={options}
        //   getOptionLabel={(option) => `${option}` || ''}
        //   renderOption={(option) => `${option[selectedKey]}` || ''}
        //   disabled={other.disabled}
        //   renderInput={(params) => (
        //     <TextField variant="outlined" {...params} {...other} />
        //   )}
        //   onChange={(__, data) => {
        //     const result = _.get(data, selectedKey);
        //     handleChange && handleChange(result || '');
        //     props.onChange(result);
        //   }}
        // />
      )}
      name={other.name}
      control={control}
      rules={rules}
      {...controllerExtras}
    />
  );
}
